/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable max-len */
import React, { ChangeEvent, FC, useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import isEmpty from 'lodash-es/isEmpty'
import * as queryString from 'querystring'

import {
  Button,
  Divider,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import { Pagination, Skeleton } from '@material-ui/lab'
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace'

import { BreadCrumbs } from '../../breadcrumbs/breadcrumbs'
import {
  FilterSearchBar,
  QuestionItem,
  removeEmptyFilterOptions,
  useQueryQuestions
} from '../common'
import { useQuestionsListStyles } from './questions-list.styles'
import { useTranslation } from '@plandi/common'

export const QuestionsList: FC = () => {
  const router = useRouter()
  const { data: translation } = useTranslation()
  const redirect = router.query.redirect as string

  const isEmptyQueryParams = isEmpty(
    removeEmptyFilterOptions(router.query.keyword)
  )
  const tabs = [
    { value: 'office', label: translation?.office?.title },
    { value: 'job', label: translation?.job?.title2 },
    { value: 'market', label: translation?.market?.title }
  ]
  const [value, setValue] = useState(
    router.query.question === 'office'
      ? 'office'
      : router.query.question === 'job'
      ? 'job'
      : 'market'
  )

  const { data: faqs, isLoading, isError } = useQueryQuestions()

  const classes = useQuestionsListStyles()

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down(960))

  const handleChange = (event: ChangeEvent<unknown>, newValue: string) => {
    setValue(newValue)
  }

  const handlerMorePage = (event: ChangeEvent<unknown>, pageValue: number) => {
    const objQuery = queryString.parse(router.asPath.split(/\?/)[1])
    router.push(
      {
        pathname: '/questions',
        query: { ...objQuery, page: pageValue }
      },
      undefined,
      { scroll: true }
    )
  }

  useEffect(() => {
    router.replace(
      { query: { question: value, redirect: redirect } },
      undefined,
      { shallow: true }
    )
    // switch (value) {
    //   case 'office':
    //     router.push(
    //       {
    //         query: { question: 'office', redirect: redirect }
    //       },
    //       undefined,
    //       { shallow: true }
    //     )
    //     break
    //   case 'job':
    //     router.push(
    //       {
    //         query: { question: 'job', redirect: redirect }
    //       },
    //       undefined,
    //       { shallow: true }
    //     )
    //     break
    //   case 'market':
    //     router.push(
    //       {
    //         query: { question: 'market', redirect: redirect }
    //       },
    //       undefined,
    //       { shallow: true }
    //     )
    //     break
    // }
  }, [value])

  return (
    <div className={classes.wrapper}>
      <BreadCrumbs
        breadcrumbInfo={[{ title: 'FAQ', href: '' }]}
        styles={{ alignSelf: 'flex-start' }}
      />
      <Button
        onClick={() => router.push(redirect)}
        variant="text"
        className={classes.btnBack}
        startIcon={<KeyboardBackspaceIcon />}
        disabled={isLoading}
      >
        {translation?.shop?.back}
      </Button>
      <Typography className={classes.title}>FAQ</Typography>
      <Tabs
        value={value}
        onChange={handleChange}
        textColor="secondary"
        indicatorColor="secondary"
      >
        {tabs.map((tab) => (
          <Tab
            key={tab.value}
            value={tab.value}
            label={tab.label}
            className={classes.tab}
          />
        ))}
      </Tabs>
      {!isMobile && <Divider className={classes.divider} />}
      <FilterSearchBar disabled={isLoading} typeForSearch={value} />
      <Typography className={classes.count}>
        {!isError &&
          (isLoading
            ? translation?.['loading-results']
            : !faqs?.data || isEmpty(faqs?.data)
            ? null
            : `${translation?.['total-results']}: ${faqs?.total}`)}
      </Typography>
      <div className={classes.content}>
        {isLoading ? (
          [...new Array(15)].map((_, i) => (
            <Skeleton className={classes.skeleton} animation="wave" key={i} />
          ))
        ) : isEmpty(faqs?.data) && !isEmptyQueryParams ? (
          <Typography style={{ marginBottom: 200 }} align="center" variant="h6">
            {translation?.['not-found-data']}
          </Typography>
        ) : !faqs?.data || isEmpty(faqs?.data) ? (
          <Typography style={{ marginBottom: 200 }} align="center" variant="h6">
            {translation?.['no-questions-found']}
          </Typography>
        ) : (
          faqs?.data.map((faq, index: number) => (
            <QuestionItem
              page={faqs.currentPage}
              key={faq.id}
              {...faq}
              index={index}
            />
          ))
        )}
      </div>
      <div className={classes.pagination}>
        <Pagination
          count={faqs?.lastPage}
          hidden={isError || faqs?.lastPage < 2 || isLoading}
          onChange={handlerMorePage}
          showFirstButton
          showLastButton
          disabled={isLoading}
          size={isMobile ? 'small' : 'medium'}
          page={Number(router.query.page || 1)}
        />
      </div>
    </div>
  )
}
